import { Injectable } from '@angular/core';
import {LinkRef, ResolverUrl} from '@kion/data-models';

@Injectable({
  providedIn: 'root'
})
export class BaseLinkResolverService {

  //TODO: create a base link resolver to use :)
  navigate(linkRef: LinkRef): ResolverUrl {
    return {url: linkRef.url?.toString(), newWindow: linkRef.target as boolean};
  }
}
